export default __webpack_public_path__ + "media/images/dlp/sign-up-save.png";